import React, { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import S3FileUpload from "react-s3/lib/ReactS3";
import BillTemplates from "../billtemplates";
import {
  Box,
  Button,
  Grid,
  Stack,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import Gst from "./Gst";
import CompanyInfo from "./CompanyInfo";
import EmployeesList from "./EmployeesList";
import UserRepository from "../../Repository/UserRepository";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { updateCompany } from "./httpCalls";
import { useDispatch, useSelector } from "react-redux";
import { clearCompany, getCompany } from "./companySlice";
import Loader from "../components/Loader";
import Config from "../../utils/Config";
import { Toast } from "../components/Toast";
import CurrencySelect from "./CurrencySelect";

const config = {
  bucketName: "ats-bucket-hardware",
  dirName: "photos",
  error: "",
  region: "us-east-1",
  accessKeyId: "AKIA44SH2DQ6NF3SXOFL",
  secretAccessKey: "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",
  headers: {
    "Access-Conrol-Allow-Origin": "*",
  },
};

const rowStyle = {
  color: "#4CAF50",
  backgroundColor: "#4CAF50",
  border: "none",
  height: "2px",
};

function CompanyProfile() {
  const dispatch = useDispatch();
  const { company, companyLoading } = useSelector((state) => state.company);
  console.log("company", company);
  const [state, setState] = useState({
    logoId: "",
    logoSignatureId:"",
    modalSignatureDelete:false,
    modalDelete: false,
    employees: [],
    partnersLogos: [],
    billStamp: null,
    loading: false,
    imageUploading: false,
    imageStampUploading: false,
    stockValue: "no",
    imeiNumberShow:"no",
  });

  useEffect(() => {
    refreshEmployees();
  }, []);

  const refreshEmployees = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await UserRepository.usersModel({
      request: {
        method: "getEmployees",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });

    let employees = [];
    data.response.data.employees.map((item) => {
      if (item.username != null) {
        employees.push(item);
      }
    });

    setState((prev) => ({ ...prev, loading: false, employees }));
  };

  const uploadImage = async (item) => {
    try {
      let { location } = await S3FileUpload.uploadFile(item, Config());
      return { name: item.name, url: location };
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const uploadLogos = async () => {
    try {
      if (state.partnersLogos.length == 0) {
        Toast("info", "Kindly select images");
        return;
      }
      setState((prev) => ({ ...prev, imageUploading: true }));
      let oldLogos = company?.partners_logos || [];
      let newLogos = [];

      const apiPromises = state.partnersLogos.map(uploadImage);
      newLogos = await Promise.all(apiPromises);
      let final = [
        ...new Map(
          [...newLogos, ...oldLogos].map((item) => [item.name, item])
        ).values(),
      ];
      let obj = {
        _id: company._id,
        _rev: company._rev,
        parent_company_code: company.parent_company_code,
        created_at: company.created_at,
        child_companies: company.child_companies,
        company_name: company.company_name,
        partners_logos: final,
      };
      await updateCompany(obj);
      dispatch(clearCompany());
      dispatch(getCompany());

      setState((prev) => ({ ...prev, imageUploading: false }));
    } catch (err) {
      console.log("err:", err);
      Toast("error", err);
      setState((prev) => ({ ...prev, imageUploading: false }));
    }
  };

  const uploadBillStamp = async () => {
    try {
      if (state.billStamp.length == 0) {
        Toast("info", "Kindly select images");
        return;
      }
      setState((prev) => ({ ...prev, imageStampUploading: true }));
      let oldLogos = company?.billStamp || [];
      let newLogos = [];

      const apiPromises = state.billStamp.map(uploadImage);
      newLogos = await Promise.all(apiPromises);
      console.log("newLogos", newLogos);

      const signatureImg = newLogos[0];

      console.log("signatureImg", signatureImg);
      // let final = [
      //   ...new Map(
      //     [...newLogos, ].map((item) => [item.name, item])
      //   ).values(),
      // ];
      let obj = {
        _id: company._id,
        _rev: company._rev,
        parent_company_code: company.parent_company_code,
        created_at: company.created_at,
        child_companies: company.child_companies,
        company_name: company.company_name,
        billStamp: signatureImg,
      };
      await updateCompany(obj);
      dispatch(clearCompany());
      dispatch(getCompany());

      setState((prev) => ({ ...prev, imageStampUploading: false }));
    } catch (err) {
      console.log("err:", err);
      Toast("error", err);
      setState((prev) => ({ ...prev, imageStampUploading: false }));
    }
  };

  const handleChange = async (e) => {
    const { value ,name } = e.target;
    const obj = {
      ...company,
      [name] : value,
    };
    await updateCompany({
      ...obj,
    });
    dispatch(getCompany());
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const toggle = (name) => {
    setState((prev) => ({
      ...prev,
      logoId: name,
      modalDelete: !prev.modalDelete,
    }));
  };

  const toggleSignature = (name) => {
    setState((prev) => ({
      ...prev,
      logoSignatureId: name,
      modalSignatureDelete: !prev.modalSignatureDelete,
    }));
  };
  const deletePartnerLogo = async () => {
    setState((prev) => ({ ...prev, modalDelete: false }));

    const filtered = company.partners_logos
      .filter((filter) => filter.name != state.logoId)
      .map((item) => item);

    await updateCompany({
      ...company,
      partners_logos: filtered,
    });
    dispatch(clearCompany());
    dispatch(getCompany());
  };


  const deleteSignaturePartnerLogo = async () => {
    setState((prev) => ({ ...prev, modalSignatureDelete: false }));

   
    await updateCompany({
      ...company,
      billStamp: null,
    });
    dispatch(clearCompany());
    dispatch(getCompany());
  };

  const updateCurrency = async (currency) => {
    const wholeObj = {
      ...company,
      currency,
    };
    console.log("currencyy", currency);
    await updateCompany({
      ...wholeObj,
    });
    dispatch(getCompany());
  };

  const handleImages = (e) => {
    const { files, name } = e.target;
    if (files && files.length > 0 && name !== "billStamp") {
      setState((prev) => ({ ...prev, partnersLogos: [...files] }));
    } else if (files && files.length > 0 && name == "billStamp") {
      setState((prev) => ({ ...prev, billStamp: [...files] }));
    } else {
      setState((prev) => ({ ...prev, billStamp: [] }));
    }
  };

  if (
    localStorage.getItem("token") == null ||
    localStorage.getItem("tokenType") != "admin"
  ) {
    window.location.reload();
  }

  return (
    <div>
      <CompanyInfo />
      <hr style={rowStyle} />
      <Grid style={{ marginTop: "30px", marginBottom: "30px" }} container>
        <CurrencySelect onChange={(currency) => updateCurrency(currency)} />
      </Grid>
      <Stack direction="row" justifyContent="space-between">
        <h3 style={{}}>Manage Stock Sale</h3>
        <FormControl>
          <RadioGroup
            row
            name="stockValue"
            value={company.stockValue ? company.stockValue : state.stockValue}
            onChange={handleChange}
          >
            <FormControlLabel
              value="yes"
              control={<Radio disableRipple />}
              label="Yes"
            />
            <FormControlLabel
              value="no"
              control={<Radio disableRipple />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Stack>

      <Stack direction="row" justifyContent="space-between">
        <h3 style={{}}>Manage Imei Number</h3>
        <FormControl>
          <RadioGroup
            row
            name="imeiNumberShow"
            value={company.imeiNumberShow ? company.imeiNumberShow : state.imeiNumberShow}
            onChange={handleChange}
          >
            <FormControlLabel
              value="yes"
              control={<Radio disableRipple />}
              label="Yes"
            />
            <FormControlLabel
              value="no"
              control={<Radio disableRipple />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Stack>

      <h3> GST </h3>
      <Gst />

      <hr style={rowStyle} />

      <Grid style={{ marginTop: "30px", marginBottom: "30px" }} container>
        <h3> Upload Partners Logos</h3>
        <Grid item lg={12}>
          <input type="file" multiple onChange={handleImages} />
          {state.imageUploading && (
            <ClipLoader size={40} color={"#4DAF51"} loading={true} />
          )}
          {!state.imageUploading && (
            <Button variant="outlined" onClick={uploadLogos}>
              Upload
            </Button>
          )}
        </Grid>
      </Grid>
      <h3>Partners</h3>
      <Grid container spacing={1}>
        {company.partners_logos &&
          company.partners_logos.map((item) => (
            <Grid align="center" item lg={2} md={2} sm={3} xs={4}>
              <Stack alignItems="center" justifyContent="center" spacing="4px">
                <img width="100px" height="100px" src={item.url} />

                <Button
                  style={{ textTransform: "none" }}
                  variant="outlined"
                  size="small"
                  onClick={() => toggle(item.name)}
                >
                  Delete
                </Button>
              </Stack>
            </Grid>
          ))}
      </Grid>

      <Grid style={{ marginTop: "30px", marginBottom: "30px" }} container>
        <h3> Upload Bill Stamp</h3>
        <Grid item lg={12}>
          <input
            type="file"
            name="billStamp"
            multiple
            onChange={handleImages}
          />
          {state.imageUploading && (
            <ClipLoader size={40} color={"#4DAF51"} loading={true} />
          )}
          {!state.imageUploading && (
            <Button variant="outlined" onClick={uploadBillStamp}>
              Upload
            </Button>
          )}
        </Grid>
      </Grid>
      <h3>Stamp</h3>
      <Grid container spacing={1}>
        {company.billStamp && (
          <Grid align="center" item lg={2} md={2} sm={3} xs={4}>
            <Stack alignItems="center" justifyContent="center" spacing="4px">
              <img width="100px" height="100px" src={company.billStamp.url} />

              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                size="small"
                onClick={() => toggleSignature(company.billStamp.name)}
              >
                Delete
              </Button>
            </Stack>
          </Grid>
        )}
      </Grid>

      <hr style={rowStyle} />

      <EmployeesList
        employees={state.employees}
        onSuccess={refreshEmployees}
        loading={state.loading}
      />

      <Loader loading={state.loading || companyLoading} />

      <BillTemplates />

      <DeleteDialog
        title="Delete Logo"
        open={state.modalDelete}
        onClose={toggle}
        onClickYes={deletePartnerLogo}
      />

      <DeleteDialog
        title="Delete Logo"
        open={state.modalSignatureDelete}
        onClose={toggle}
        onClickYes={deleteSignaturePartnerLogo}
      />
    </div>
  );
}

export default CompanyProfile;
